<template>
  <table class="voucher-table">
    <caption>이용권 상세표</caption>
    <colgroup>
      <col style="width: 64px;">
      <col>
    </colgroup>
    <tbody>
    <tr>
      <th scope="row">동시시청</th>
      <td class="concurrency-count">{{ concurrency }}</td>
    </tr>
    <tr>
      <th scope="row">화질</th>
      <td>{{ quality }}</td>
    </tr>
    <tr>
      <th scope="row">이용기기</th>
      <td>{{ supportDevice }}</td>
    </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'VoucherTableList',
  props: {
    supportDevice: {
      type: String
    },
    quality: {
      type: String
    },
    concurrency: {
      type: String
    }
  }
}
</script>
